import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Transactions from './views/Transactions.vue'
import AdminLayout from './views/AdminLayout.vue'
import CalendarManagement from './views/CalendarManagement.vue'
import WalkinTransactions from './views/WalkinTransactions.vue'
import BranchReports from './views/BranchReports.vue'
import Queuing from './views/Queuing.vue'
import JobOrder from './views/JobOrder.vue'
import reprintJo from './views/reprintJo.vue'
import ServiceApproval from './views/ServiceApproval.vue'
import MechanicAssignment from './views/MechanicAssignment.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'adminlayout',
            redirect: '/transactions',
            meta : {
                public: true,
            },
            component: AdminLayout,
            children: [
                {
                    path: '/service-approval',
                    name: 'service-approval',
                    component: ServiceApproval,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/transactions',
                    name: 'transactions',
                    component: Transactions,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/calendar-management',
                    name: 'calendar-management',
                    component: CalendarManagement,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/walk-in-transactions',
                    name: 'walk-in-transactions',
                    component: WalkinTransactions,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/reports',
                    name: 'reports',
                    component: BranchReports,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/mechanic-assignment',
                    name: 'mechanic-assignment',
                    component: MechanicAssignment,
                    meta : {
                        public: false,
                    }
                },
            ]
        },
        {
            path: '/job-order',
            name: 'job-order',
            component: JobOrder,
            meta : {
                public: false,
            }
        },
        {
            path: '/re-job-order',
            name: 're-job-order',
            component: reprintJo,
            meta : {
                public: false,
            }
        },
        {
            path: '/queuing',
            name: 'Queuing',
            component: Queuing,
            meta : {
                public: false,
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta : {
                public: true,
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta : {
                public: true,
            }
        },
    ]
})
